import React, {useEffect, useRef, useState} from "react";
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import MesaOperationsLoan from "./mesa-operations-loan";
import MesaOperationsOwn from "./mesa-operations-own";


function MesaOperations() {


    return (
        <div className="container-fluid flex-grow-1 container-p-y">
            
            <div className="row">

                <Tabs aria-label="tabs" defaultValue={0} sx={{ bgcolor: 'transparent' }} >
                    <TabList
                        disableUnderline
                        sx={{
                        p: 0.5,
                        gap: 0.5,
                        borderRadius: 'xl',
                        // bgcolor: 'background.level1',
                        bgcolor: 'rgba(131, 118, 109, 0.16)',
                        [`& .${tabClasses.root}[aria-selected="true"]`]: {
                            boxShadow: 'sm',
                            bgcolor: 'background.surface',
                            // bgcolor: '#FFFFFF',
                        },
                        }}
                    >
                        <Tab disableIndicator>Prestamos</Tab>
                        <Tab disableIndicator>Posición Propia</Tab>
                    </TabList>
                            
                    <TabPanel value={0}>
                        <MesaOperationsLoan />
                    </TabPanel>

                    <TabPanel value={1}>
                        <MesaOperationsOwn />
                    </TabPanel>

                </Tabs>
            </div>
            
    

        </div>   
    );

}

export default MesaOperations;